import { Menu } from '@mantine/core'
import type { ReactNode } from 'react'
import { colors } from 'settings/colors'
import { useIsWideScreen } from 'utils/useIsWideScreen'

type ResponsiveMenuItemProps = {
  onClick: () => void
  children: ReactNode
}

export const ResponsiveMenuItem = ({ onClick, children, ...rest }: ResponsiveMenuItemProps) => {
  const isWideScreen = useIsWideScreen()

  return (
    <Menu.Item
      {...rest}
      onClick={onClick}
      css={{
        fontSize: '15px',
        fontWeight: 500,
        ...(isWideScreen
          ? {
              paddingTop: '6px',
              paddingBottom: '6px',
            }
          : {
              'display': 'flex',
              'alignItems': 'center',
              'height': '50px',
              'textDecoration': 'underline',
              'color': colors.blue800,
              'paddingLeft': '0',
              '&:hover, &:focus': {
                backgroundColor: 'transparent',
              },
            }),
      }}
    >
      {children}
    </Menu.Item>
  )
}
